import { Component, DestroyRef, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { OrderService } from '../../services/order/order.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Order } from '../../lib/interfaces/Order';
import { CommonService } from '../../services/common/common.service';
import { Observable, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-order-confirm',
    templateUrl: './order-confirm.component.html',
    styleUrls: ['./order-confirm.component.scss'],
})
export class OrderConfirmComponent implements OnInit {
    @ViewChild('printSection', { read: ElementRef }) printSection!: ElementRef;

    protected order?: Order;

    private commonService: CommonService = inject(CommonService);
    private orderService: OrderService = inject(OrderService);
    private router: Router = inject(Router);
    private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
    private destroyRef: DestroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.activatedRoute.paramMap
            .pipe(
                switchMap((params: ParamMap): Observable<Order> => {
                    const identificationTag: string | null = params.get('identificationTag');

                    this.order = undefined;

                    if (!this.orderService.order.orderProducts && !identificationTag) {
                        void this.router.navigateByUrl('/bestellen');
                        return new Observable<never>();
                    }

                    if (identificationTag) {
                        return this.orderService.fetchOrderByTag(identificationTag);
                    } else {
                        this.order = this.orderService.order;
                        this.orderService.order = {} as Order;
                        return new Observable<never>();
                    }
                }),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe({
                next: (order: Order): void => {
                    this.order = order;
                },
                error: () => {
                    void this.router.navigateByUrl('/bestellen');
                },
            });
    }

    protected printOrderDetails(): void {
        if (!this.commonService.IsPlatformBrowser()) return;

        window.print();
    }
}
